import { useEffect, useState } from "react";
import { Container, Row, Col, Card, Button, Spinner } from "react-bootstrap";

const Internships = () => {
  const [internships, setInternships] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("https://skillsuprise.com/get-internships.php")
      .then(res => res.json())
      .then(data => {
        if (data.status === "success") {
          setInternships(data.data);
        }
        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        setLoading(false);
      });
  }, []);

  // ✅ VIEW DETAILS REDIRECT
  const handleViewDetails = (id) => {
    window.open(
      `https://www.skillsuprise.com/internship/${id}`,
      "_blank"
    );
  };

  return (
    <div style={{ background: "#f5f7fa", minHeight: "100vh", padding: "40px 0" }}>
      <Container>
        <h2 className="text-center fw-bold mb-4">Internships</h2>

        {loading ? (
          <div className="text-center">
            <Spinner animation="border" />
          </div>
        ) : (
          <Row>
            {internships.map((item, index) => (
              <Col md={6} lg={4} key={index} className="mb-4">
                <Card
                  style={{
                    borderRadius: "15px",
                    boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
                    border: "none",
                    height: "100%"
                  }}
                >
                  <Card.Body className="d-flex flex-column">
                    
                    {/* Company */}
                    <div className="d-flex align-items-center mb-3">
                      <img
                        src={item.company_logo}
                        alt="logo"
                        style={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "8px",
                          marginRight: "10px",
                          objectFit: "cover"
                        }}
                      />
                      <div>
                        <div className="fw-bold">{item.title}</div>
                        <small className="text-muted">{item.mode}</small>
                      </div>
                    </div>

                    {/* Title */}
                    {/* <Card.Title style={{ fontSize: "16px", fontWeight: "600" }}>
                      {item.title}
                    </Card.Title> */}

                    {/* Tags */}
                    <div className="mb-2">
                      {item.category.map((cat, i) => (
                        <span
                          key={i}
                          style={{
                            fontSize: "12px",
                            background: "#e3f2fd",
                            padding: "4px 10px",
                            borderRadius: "20px",
                            marginRight: "5px"
                          }}
                        >
                          {cat}
                        </span>
                      ))}
                    </div>

                    {/* Details */}
                    <div className="text-muted mb-2" style={{ fontSize: "14px" }}>
                      💰 ₹{item.stipend}/month
                    </div>

                    <div className="text-muted mb-2" style={{ fontSize: "14px" }}>
                      ⏳ {item.duration} Months
                    </div>

                    <div className="text-muted mb-2" style={{ fontSize: "14px" }}>
                      📍 {item.mode}
                    </div>

                    <div className="text-muted mb-2" style={{ fontSize: "14px" }}>
                      👥 {item.openings} openings
                    </div>

                    {/* <div className="text-danger mb-3" style={{ fontSize: "13px" }}>
                      Apply by {item.apply_by}
                    </div> */}

                    {/* Button */}
                    <Button
                      variant="primary"
                      style={{ borderRadius: "10px", marginTop: "auto" }}
                      onClick={() => handleViewDetails(item.id)}
                    >
                      View Details
                    </Button>

                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        )}
      </Container>
    </div>
  );
};

export default Internships;